var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-main",
    {
      staticClass: "admin-program",
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("h1", { staticClass: "title" }, [
                    _vm._v(_vm._s("Program: " + _vm.postData.title.rendered)),
                  ]),
                  _c("k-actions", {
                    staticClass: "header-actions",
                    attrs: { actions: _vm.actions, icons: _vm.icons },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [{ name: "bar", rawName: "v-bar" }],
          staticClass: "main-content",
        },
        [
          _c(
            "div",
            { staticClass: "inner" },
            [
              _vm.postData.collections.releases
                ? _c("section", { staticClass: "objects episodes" }, [
                    _c("div", { staticClass: "header" }, [
                      _c("h2", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.episodesTitle)),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "body" },
                      _vm._l(_vm.episodes, function (object) {
                        return _c("k-admin-release", {
                          key: object.id,
                          staticClass: "item",
                          attrs: {
                            object: object,
                            active: _vm.currentObject === object,
                          },
                          on: { focus: _vm.setCurrentObject },
                        })
                      }),
                      1
                    ),
                    _c("div", { staticClass: "foooter" }, [
                      _c("div", { staticClass: "actions" }),
                    ]),
                  ])
                : _vm._e(),
              _vm.postData.collections.archives
                ? _c("section", { staticClass: "objects archives" }, [
                    _c("div", { staticClass: "header" }, [
                      _c("h2", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.archivesTitle)),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "body" },
                      _vm._l(_vm.archives, function (object) {
                        return _c("k-admin-release", {
                          key: object.id,
                          staticClass: "item",
                          attrs: {
                            object: object,
                            active: _vm.currentObject === object,
                          },
                          on: { focus: _vm.setCurrentObject },
                        })
                      }),
                      1
                    ),
                    _c("div", { staticClass: "foooter" }, [
                      _c("div", { staticClass: "actions" }),
                    ]),
                  ])
                : _vm._e(),
              _vm.post.objects
                ? _vm._l(_vm.post.objects, function (section) {
                    return _c("section", { staticClass: "objects" }, [
                      _c("div", { staticClass: "header" }, [
                        _c("h2", { staticClass: "title" }, [
                          _vm._v(_vm._s(section.title)),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "body" },
                        [
                          _vm._l(section.objects, function (object) {
                            return [
                              object.error_data
                                ? _c(
                                    "div",
                                    {
                                      key:
                                        object.error_data.ach_access_denied &&
                                        object.error_data.ach_access_denied
                                          .redirect,
                                      staticClass: "item denied",
                                    },
                                    [
                                      _c("i-lock", {
                                        staticClass: "icon",
                                        attrs: { title: "Denied" },
                                      }),
                                      _c("span", { staticClass: "text" }, [
                                        _vm._v("Permission denied"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    { key: object.id, staticClass: "item" },
                                    [
                                      _c("router-link", {
                                        staticClass: "title",
                                        attrs: {
                                          to:
                                            "/admin/content/program/object/" +
                                            object.id,
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            object.title &&
                                              object.title.rendered
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ]
                          }),
                        ],
                        2
                      ),
                      _c("div", { staticClass: "foooter" }, [
                        _c("div", { staticClass: "actions" }),
                      ]),
                    ])
                  })
                : _vm._e(),
              _c("k-actions", {
                staticClass: "footer-actions",
                attrs: {
                  actions: _vm.actions,
                  icons: _vm.icons,
                  type: "icon-text",
                },
              }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }